import React, { useState, useEffect } from 'react';
import { fetchUserAttributes, updateUserAttributes, updatePassword } from 'aws-amplify/auth';

export default function Settings({ user }) {
  const [attributes, setAttributes] = useState({});
  // 各入力項目のステート
  const [nickname, setNickname] = useState(''); // 会員名（usernameは変更不可なため属性で管理する場合）
  const [email, setEmail] = useState('');
  const [gender, setGender] = useState('');
  
  // パスワード用
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadAttributes();
  }, []);

  async function loadAttributes() {
    try {
      const attrs = await fetchUserAttributes();
      setAttributes(attrs);
      setEmail(attrs.email || '');
      setGender(attrs.gender || '未回答'); // App.jsのname="gender"に準拠
      setNickname(attrs.nickname || ''); // ニックネーム取得
    } catch (err) {
      console.error('属性取得エラー:', err);
    }
  }

  // プロフィール更新（メール・性別など）
  async function handleUpdateProfile() {
    setLoading(true);
    try {
      await updateUserAttributes({
        userAttributes: {
          email: email,
          gender: gender, // App.jsに合わせて 'custom:' なし
          nickname: nickname, // ニックネーム更新を追加
        },
      });
      setMessage('プロフィールを更新しました！');      
      // ★ ここがポイント：1.5秒後にリロードして最新情報を反映させる
      setTimeout(() => {
        window.location.reload();
      }, 1500);
      
    } catch (err) {
      console.error(err);
      setMessage('プロフィールの更新に失敗しました。');
    } finally {
      setLoading(false);
    }
  }

  // パスワード更新
  async function handleUpdatePassword() {
    if (!oldPassword || !newPassword) {
      setMessage('現在のパスワードと新しいパスワードを入力してください。');
      return;
    }
    setLoading(true);
    try {
      await updatePassword({ oldPassword, newPassword });
      setMessage('パスワードを更新しました！');
      setOldPassword('');
      setNewPassword('');
    } catch (err) {
      console.error(err);
      setMessage('パスワードの更新に失敗しました。現在のパスワードが正しいか確認してください。');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{ padding: '80px 20px 40px', maxWidth: '500px', margin: '0 auto', fontFamily: 'sans-serif' }}>
      <h2 style={{ borderLeft: '5px solid #e74c3c', paddingLeft: '10px', marginBottom: '25px' }}>会員設定</h2>
      
      {/* 基本情報セクション */}
      <div style={{ background: '#fff', padding: '20px', borderRadius: '15px', marginBottom: '20px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
        <h3 style={{ fontSize: '16px', marginTop: 0, color: '#2c3e50' }}>基本情報の変更</h3>
        
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#7f8c8d' }}>会員名 (表示用)</label>
          <input 
            type="text" 
            value={user?.username} 
            disabled 
            style={{ width: '100%', padding: '10px', marginTop: '5px', background: '#f9f9f9', border: '1px solid #ddd', borderRadius: '5px', color: '#999' }}
          />
          <small style={{ fontSize: '10px', color: '#999' }}>※システム上のユーザー名は変更できません</small>
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#7f8c8d' }}>ニックネーム</label>
          <input 
            type="text" 
            value={nickname} 
            onChange={(e) => setNickname(e.target.value)}
            style={{ width: '100%', padding: '10px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '5px' }}
          />
        </div>

        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#7f8c8d' }}>メールアドレス</label>
          <input 
            type="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: '100%', padding: '10px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '5px', boxSizing: 'border-box' }}
          />
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#7f8c8d' }}>性別</label>
          <select 
            value={gender} 
            onChange={(e) => setGender(e.target.value)}
            style={{ width: '100%', padding: '10px', marginTop: '5px', border: '1px solid #ddd', borderRadius: '5px', background: '#fff' }}
          >
            <option value="男性">男性</option>
            <option value="女性">女性</option>
            <option value="未回答">未回答</option>
          </select>
        </div>
        
        <button 
          onClick={handleUpdateProfile} 
          disabled={loading}
          style={{ background: '#27ae60', color: '#fff', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', width: '100%', fontWeight: 'bold' }}
        >
          プロフィールを保存
        </button>
      </div>

      {/* パスワードセクション */}
      <div style={{ background: '#fff', padding: '20px', borderRadius: '15px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
        <h3 style={{ fontSize: '16px', marginTop: 0, color: '#2c3e50' }}>パスワードの変更</h3>
        <input 
          type="password" 
          placeholder="現在のパスワード" 
          value={oldPassword}
          onChange={e => setOldPassword(e.target.value)} 
          style={{ width: '100%', padding: '10px', marginBottom: '10px', border: '1px solid #ddd', borderRadius: '5px', boxSizing: 'border-box' }} 
        />
        <input 
          type="password" 
          placeholder="新しいパスワード" 
          value={newPassword}
          onChange={e => setNewPassword(e.target.value)} 
          style={{ width: '100%', padding: '10px', marginBottom: '15px', border: '1px solid #ddd', borderRadius: '5px', boxSizing: 'border-box' }} 
        />
        <button 
          onClick={handleUpdatePassword}
          disabled={loading}
          style={{ background: '#2c3e50', color: '#fff', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', width: '100%', fontWeight: 'bold' }}
        >
          パスワードを更新
        </button>
      </div>
      
      {message && (
        <div style={{ 
          marginTop: '20px', padding: '12px', borderRadius: '10px', textAlign: 'center', fontWeight: 'bold',
          backgroundColor: message.includes('失敗') ? '#fdecea' : '#eafaf1',
          color: message.includes('失敗') ? '#e74c3c' : '#27ae60',
          border: `1px solid ${message.includes('失敗') ? '#e74c3c' : '#27ae60'}`
        }}>
          {message}
        </div>
      )}
    </div>
  );
}